import { createContext, useState } from "react";
import PropTypes from "prop-types";

export const SettingFormContext = createContext();
const SettingContextProvider = ({ children }) => {
  const [editData, setEditData] = useState([]);

  return (
    <SettingFormContext.Provider
      value={{
        editData,
        setEditData,
      }}
    >
      {children}
    </SettingFormContext.Provider>
  );
};
SettingContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SettingContextProvider;
